
const openedAccordions = document.querySelectorAll(".accordion--open");

/**
 *
 * @param {HTMLElement} accordion element with class accordion
 * @param {Boolean} isTransition if true accordion opens with transion
 */
export function openAccordion(accordion, isTransition = true) {
    const details = accordion.querySelector(".accordion__details");

    if (!details) return;

    const detailsWrapper = details.querySelector(".accordion__details-wrapper");

    if (!detailsWrapper) {
        console.error(`${details} accordion details wrapper not provided`);

        return;
    }

    if (isTransition) {
        details.style.transition = "max-height .3s ease";
    } else {
        details.style.transition = "none";
    }

    accordion.classList.add("accordion--open");
    details.style.maxHeight = `${detailsWrapper.clientHeight}px`;
}

/**
 *
 * @param {HTMLElement} accordion element with class accordion
 * @param {Boolean} isTransition if true accordion opens with transion
 */
export function closeAccordion(accordion, isTransition = true, afterTransitionCb = null) {
    const details = accordion.querySelector(".accordion__details");

    if (!details) return;

    const detailsWrapper = details.querySelector(".accordion__details-wrapper");

    if (!detailsWrapper) {
        console.error(`${details} accordion details wrapper not provided`);

        return;
    }

    if (isTransition) {
        details.style.transition = "max-height .3s ease";

        const handleTransiotionEnd = function(event) {
            if (afterTransitionCb) afterTransitionCb();
            console.log(event.propertyName);
            details.removeEventListener("transitionend", handleTransiotionEnd);
        };

        details.addEventListener("transitionend", handleTransiotionEnd);
    } else {
        details.style.transition = "none";
    }

    accordion.classList.remove("accordion--open");
    details.style.maxHeight = 0;
}

function onClick(event) {
    const button = event.target.closest(".accordion__button");

    if (!button) return;

    const accordion = button.closest(".accordion");

    if (!accordion) {
        console.error(`${button} wrong target element`);
        return;
    }

    const isOpen = accordion.classList.contains("accordion--open");

    if (isOpen) {
        closeAccordion(accordion);
    } else {
        openAccordion(accordion);
    }
}

function initOpenedAccordions() {
    openedAccordions.forEach((accordion) => {
        openAccordion(accordion, false);
    });
}

export function initAccordions() {
    const accordions = document.querySelectorAll(".accordion");

    document.addEventListener("click", onClick);

    initOpenedAccordions();
}
